import { render, staticRenderFns } from "./PersonalHomepage.vue?vue&type=template&id=76f0a326&scoped=true&"
import script from "./PersonalHomepage.vue?vue&type=script&lang=ts&"
export * from "./PersonalHomepage.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalHomepage.vue?vue&type=style&index=0&id=76f0a326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f0a326",
  null
  
)

export default component.exports